(function ($) {
    $(document).ready(function () {
        const $slider = $('.demo_audio_slider');

        $slider.owlCarousel({
            loop: false,
            margin: 30,
            nav: true,
            dots: false,
            navText: [
                '<svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);"><mask id="path-1-inside-1_69_2685_prev" fill="white"><path d="M0 16C0 7.71573 6.71573 1 15 1C23.2843 1 30 7.71573 30 16C30 24.2843 23.2843 31 15 31C6.71573 31 0 24.2843 0 16Z"/></mask><path d="M0 16M30 16M30 16M0 16M15 1M30 16M15 31M0 16M15 31V30C7.26801 30 1 23.732 1 16H0H-1C-1 24.8366 6.16344 32 15 32V31ZM30 16H29C29 23.732 22.732 30 15 30V31V32C23.8366 32 31 24.8366 31 16H30ZM15 1V2C22.732 2 29 8.26801 29 16H30H31C31 7.16344 23.8366 0 15 0V1ZM15 1V0C6.16344 0 -1 7.16344 -1 16H0H1C1 8.26801 7.26801 2 15 2V1Z" fill="#AFAFAF" mask="url(#path-1-inside-1_69_2685_prev)"/><path d="M13.7422 21.729L12.7192 20.717L16.9102 16.57L12.7192 12.423L13.7422 11.411L18.9122 16.57L13.7422 21.729Z" fill="#AFAFAF"/></svg>',
                '<svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-inside-1_69_2685_next" fill="white"><path d="M0 16C0 7.71573 6.71573 1 15 1C23.2843 1 30 7.71573 30 16C30 24.2843 23.2843 31 15 31C6.71573 31 0 24.2843 0 16Z"/></mask><path d="M0 16M30 16M30 16M0 16M15 1M30 16M15 31M0 16M15 31V30C7.26801 30 1 23.732 1 16H0H-1C-1 24.8366 6.16344 32 15 32V31ZM30 16H29C29 23.732 22.732 30 15 30V31V32C23.8366 32 31 24.8366 31 16H30ZM15 1V2C22.732 2 29 8.26801 29 16H30H31C31 7.16344 23.8366 0 15 0V1ZM15 1V0C6.16344 0 -1 7.16344 -1 16H0H1C1 8.26801 7.26801 2 15 2V1Z" fill="#AFAFAF" mask="url(#path-1-inside-1_69_2685_next)"/><path d="M13.7422 21.729L12.7192 20.717L16.9102 16.57L12.7192 12.423L13.7422 11.411L18.9122 16.57L13.7422 21.729Z" fill="#AFAFAF"/></svg>'
            ],
            responsive: {
                0: { items: 1 },
                768: { items: 2 },
                1100: { items: 3 }
            },
            onInitialized: function () {
                toggleOwlNav($slider);
            },
            onResized: function () {
                toggleOwlNav($slider);
            }
        });

        function toggleOwlNav($slider) {
            const owl = $slider.data('owl.carousel');
            if (!owl) return;

            const totalItems = owl._items.length;
            const visibleItems = owl.settings.items;

            const $nav = $slider.find('.owl-nav');

            if (totalItems <= visibleItems) {
                $nav.hide();
            } else {
                $nav.show();
            }
        }

        function resetAudioItem($wrap) {
            const audio = $wrap.find('.demo-audio').get(0);

            if (audio) {
                audio.pause();
                audio.currentTime = 0;
            }

            $wrap.removeClass('is-playing');
            $wrap.closest('.item_inner').removeClass('is-playing');
        }

        function playAudioItem($wrap) {
            const audio = $wrap.find('.demo-audio').get(0);

            if (!audio) return;

            $('.js-audio-toggle').not($wrap).each(function () {
                resetAudioItem($(this));
            });

            audio.play();
            $wrap.addClass('is-playing');
            $wrap.closest('.item_inner').addClass('is-playing');
        }

        $(document).on('click', '.js-audio-toggle', function () {
            const $wrap = $(this);
            const audio = $wrap.find('.demo-audio').get(0);

            if (!audio) return;

            if (audio.paused) {
                playAudioItem($wrap);
            } else {
                audio.pause();
                $wrap.removeClass('is-playing');
                $wrap.closest('.item_inner').removeClass('is-playing');
            }

            audio.onended = function () {
                resetAudioItem($wrap);
            };
        });

        $slider.on('changed.owl.carousel', function () {
            $('.js-audio-toggle').each(function () {
                resetAudioItem($(this));
            });
        });
    });
})(jQuery);